type Data = { volume: number };

export function sortByTotalVolume(itemA: Data, itemB: Data): number {
  return itemB.volume - itemA.volume;
}
